import ListHeader from "@/common/components/ListHeader";
import Table from "@/common/components/Table";
import TextField from "@/common/components/TextField";
import { Mapper } from "@/common/services/mapper";
import { useGeneralDocuments } from "@/features/generalDocuments/hooks/useGeneralDocuments";
import { GeneralDocumentTransformer } from "@/features/generalDocuments/services/generalDocumentTransformer";
import { GeneralDocumentData, GeneralDocumentTableItem } from "@/features/generalDocuments/types/generalDocuments";
import { FileBadge, Search } from "lucide-react";
import { defaultColumns } from "../../constants/columns.constant";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import useDebounce from "@/common/hooks/useDebounce";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";

const GeneralDocuments = () => {
  const { filterParams, setFilterParams } = useFilterParams();

  const [search, setSearch] = useDebounce(filterParams.search || '');

  const {
    data: documents,
    meta,
    isPending: isPendingGeneralDocuments,
    isLoading: isLoadingGeneralDocuments,
    error: generalDocumentsError = {} as any,
    refetch: refetchGeneralDocuments,
  } = useGeneralDocuments({
    filters: {
      search: search,
      page: filterParams.page || 1,
    },
    mapper: Mapper.mapWithTransformer<GeneralDocumentData[], GeneralDocumentTableItem[]>({
      transformer: GeneralDocumentTransformer.tableTransformer('Admin::GeneralDocuments::Show')
    })
  });

  return (
    <div>
      <div className="flex flex-col gap-6">
        <ListHeader
          Icon={<FileBadge className="w-10 h-10" strokeWidth={1.5} />}
          title="Documentos"
          createButtonText="Novo documento"
          operationKlassToCheckPermission="Admin::GeneralDocuments::Create"
          dataTestid="create_documents_list_button"
          disableCreateButton={isPendingGeneralDocuments || generalDocumentsError?.status === 403}
        />

        <ErrorMessageWrapper
          className="max-h-[calc(100vh-128px)]"
          statusCode={generalDocumentsError?.status}
          refetchFunction={refetchGeneralDocuments}
        >
          <div className="h-[calc(100vh-128px)] flex flex-col gap-6">
            <TextField
              LeftIcon={<Search />}
              placeholder="Pesquisar"
              className="rounded-sm shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.5)]"
              onChange={(e) => {
                setSearch((e.target as HTMLInputElement).value);
                setFilterParams((prev) => ({ ...prev, search: (e.target as HTMLInputElement).value }))
              }}
              value={filterParams.search}
            />
            <Table
              columns={defaultColumns}
              isLoadingData={isLoadingGeneralDocuments}
              page={filterParams.page || 1}
              rows={documents}
              totalPages={meta.total_pages}
              totalCount={meta.total}
              hasPagination
              setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
            />
          </div>
        </ErrorMessageWrapper>
      </div>
    </div>
  );
};

export default GeneralDocuments;
